import { Message } from '@iwoca/orion';
import { t } from '@lingui/core/macro';
import styles from '../EarlyRepaymentCalculator.module.css';

type TProps = {
  error: Error | string | null;
};

export const CalculatorError = ({ error }: TProps) => {
  if (!error) {
    return null;
  }

  // If the error returned from LAPI client is usable, parse and display it - if not, set default error message
  const buildErrorMessage = () => {
    if (typeof error === 'string') {
      return error;
    }

    try {
      if (typeof JSON.parse(error?.message)?.detail !== 'string') {
        throw Error;
      }

      return JSON.parse(error?.message)?.detail;
    } catch {
      return t`Sorry an error has occurred`;
    }
  };

  return (
    <Message
      className={styles.errorMessage}
      message={buildErrorMessage()}
      type="error"
    />
  );
};
